// Meta Pixel utility for tracking events
// Pixel ID: 402358119036588

/**
 * Initialize Meta Pixel (if not already loaded via HTML)
 * This function ensures fbq is available
 */
export const initMetaPixel = () => {
  if (window.fbq) {
    return; // Already initialized
  }
  
  // If fbq is not available, initialize it
  window.fbq = window.fbq || function() {
    (window.fbq.q = window.fbq.q || []).push(arguments);
  };
  window.fbq.l = +new Date();
};

/**
 * Track a custom event
 * @param {string} eventName - The name of the event
 * @param {object} params - Optional parameters for the event
 */
export const trackEvent = (eventName, params = {}) => {
  if (window.fbq) {
    window.fbq('track', eventName, params);
    console.log(`Meta Pixel Event: ${eventName}`, params);
  } else {
    console.warn('Meta Pixel not initialized');
  }
};

/**
 * Track PageView event
 */
export const trackPageView = () => {
  trackEvent('PageView');
};

/**
 * Track InitiateCheckout event
 * Triggered when user starts the checkout process
 * @param {object} params - Optional parameters (value, currency, content_name, etc.)
 */
export const trackInitiateCheckout = (params = {}) => {
  trackEvent('InitiateCheckout', params);
};

/**
 * Track AddPaymentInfo event
 * Triggered when payment information is added
 * @param {object} params - Optional parameters (value, currency, content_name, etc.)
 */
export const trackAddPaymentInfo = (params = {}) => {
  trackEvent('AddPaymentInfo', params);
};

/**
 * Track Purchase event
 * Triggered when a purchase is completed
 * @param {object} params - Should include value, currency, content_name, content_ids, etc.
 */
export const trackPurchase = (params = {}) => {
  trackEvent('Purchase', params);
};

/**
 * Track ViewContent event
 * Triggered when content/product is viewed
 * @param {object} params - Optional parameters (content_name, content_ids, value, currency, etc.)
 */
export const trackViewContent = (params = {}) => {
  trackEvent('ViewContent', params);
};

/**
 * Track AddToCart event
 * Triggered when an item is added to cart
 * @param {object} params - Optional parameters (content_name, content_ids, value, currency, etc.)
 */
export const trackAddToCart = (params = {}) => {
  trackEvent('AddToCart', params);
};

/**
 * Track CompleteRegistration event
 * Triggered when user completes registration
 * @param {object} params - Optional parameters
 */
export const trackCompleteRegistration = (params = {}) => {
  trackEvent('CompleteRegistration', params);
};

/**
 * Track Lead event
 * Triggered when a lead is generated
 * @param {object} params - Optional parameters
 */
export const trackLead = (params = {}) => {
  trackEvent('Lead', params);
};

/**
 * Track Search event
 * Triggered when user searches
 * @param {object} params - Optional parameters (search_string, etc.)
 */
export const trackSearch = (params = {}) => {
  trackEvent('Search', params);
};

/**
 * Set user data for advanced matching
 * @param {object} userData - User data object (email, phone_number, first_name, last_name, etc.)
 */
export const setUserData = (userData) => {
  if (window.fbq) {
    window.fbq('set', 'user_data', userData);
  }
};

/**
 * Track custom conversions
 * @param {string} pixelId - Custom pixel ID (if different from main)
 * @param {string} eventName - Event name
 * @param {object} params - Optional parameters
 */
export const trackCustomConversion = (pixelId, eventName, params = {}) => {
  if (window.fbq) {
    window.fbq('trackSingle', pixelId, eventName, params);
  }
};

